Returns routable AI agents available to the authenticated organization.

Use this endpoint before `POST /public/v1/calls/` to discover which `ai_agent_id` values can be used and which dynamic variables each agent requires.

<ApiCodeExamples exampleId="agentsList" />

<ApiResponseExamples exampleId="agentsList" />

## Required scope

- `agents.read`

## Endpoints

- `GET /public/v1/agents/`: paginated list.
- `GET /public/v1/agents/{id}/`: detail for one agent.

The detail response uses the same field shape as the list item.

## Query parameters

- `page` (`integer`, optional): page number.
- `page_size` (`integer`, optional): items per page. Default `25`, maximum `100`.
- `search` (`string`, optional): searches by agent name.
- `ordering` (`string`, optional): `name` or `-name`.

## Response fields

- `id` (`uuid`): agent public id to send as `ai_agent_id`.
- `name` (`string`): agent name.
- `variables` (`array<string>`): dynamic variable keys required by this agent. Every key listed here must be sent in `dynamic_variables` when creating a call.
- `transfer_target_required` (`boolean`): whether `POST /public/v1/calls/` must include `transfer_target`.
- `requires_pre_call_script` (`boolean`): whether `POST /public/v1/calls/` must include a valid `pre_call_script_id`.

Only active outbound agents that pass the same runtime routing validation used by campaigns and the launcher appear here. Inbound agents are never accepted for public API call creation.

## Expected errors

- `401 Unauthorized`: invalid, expired, revoked, missing, or IP-blocked token.
- `403 Forbidden`: the credential does not have `agents.read`.
- `404 Not Found`: detail id is not available to the organization.
- `429 Too Many Requests`: credential rate limit exceeded.
